import { render, staticRenderFns } from "./MenuTopicEdit.vue?vue&type=template&id=31bdf5b6&scoped=true&"
import script from "./MenuTopicEdit.vue?vue&type=script&lang=js&"
export * from "./MenuTopicEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bdf5b6",
  null
  
)

export default component.exports